
import React, { forwardRef } from "react";
import { Button, Text, Link } from "@ui-component-library";

const ThankYouStep = forwardRef(({ onNext, errors }, ref) => {

    if (errors) {
        return (
            <div className="h-full flex flex-col justify-center items-center">
                <div className="w-full md:w-[500px] px-10 grid grid-row gap-4">
                    <Text variant="text-xl/leading-normal/normal" className="text-white">Oj då, vi gick vilse i skogen!.</Text>
                    <Text variant="text-base/leading-normal/normal" className="text-white">Något gick fel när vi försökte skicka in ditt formulär. Vi undersöker problemet och löser det så snabbt vi kan – tack för ditt tålamod!</Text>
                    <Text variant="text-base/leading-normal/normal" className="text-white">Behöver du hjälp? Ring oss på <Link href="tel:08339944" underline className="text-spring-yellow-500">08 33 99 44</Link> eller mejla oss på <Link href="mailto:information@treebula.se" underline className="text-spring-yellow-500">information@treebula.se</Link></Text>
                </div>
                <div className="fixed bottom-0 left-0 w-full sm:static sm:w-auto sm:h-auto sm:flex sm:justify-center sm:items-center mt-4">
                    <div className="flex justify-center items-center py-4 px-2 sm:py-0">
                        <Button
                            onClick={() => window.location.reload()}
                            variant="quaternary"
                            fullWidth
                        >
                            Försök igen
                        </Button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="h-full flex flex-col justify-center items-center">
            <div className="w-full md:w-[500px] px-10 grid grid-row gap-4">
                <Text variant="text-xl/leading-normal/normal" className="text-white">Tack! Vi återkommer till dig så snabbt som möjligt.</Text>
                <Text variant="text-base/leading-normal/normal" className="text-white">Medan vi behandlar din förfrågan kan du passa på att skapa en digital skogsbruksplan. Det ger dig en bättre överblick över din
                    skog och dess potential.</Text>


            </div>
            <div className="fixed bottom-0 left-0 w-full sm:static sm:w-auto sm:h-auto sm:flex sm:justify-center sm:items-center mt-4">
                <div className="flex justify-center items-center py-4 px-2 sm:py-0">
                    <Button
                        onClick={() => window.location.href = "/min-skog/?view=overblick"}
                        variant="quaternary"
                        fullWidth
                    >
                        Skapa skogsbruksplan
                    </Button>
                </div>
            </div>
        </div>
    )
});

export default ThankYouStep;